import { useState, ChangeEventHandler } from "react"
import { Input } from "../../../Components/Form/Inputs"
import FormPage from "../../../Components/Form/Page/FormPage"
import useBriefContext from "../../../Hooks/Brief/useBriefContext"
import InputView from "../InputView"
import './GuestNumberInput.less'

interface InputText {
  titlePrefix: string
  guestLabel: string
}

const inputTextByType: Record<string, InputText> = {
  'Party': { titlePrefix: 'Woohoo! 🕺💃', guestLabel: 'party people' }, 
  'Private Dining': { titlePrefix: 'Delicious! 🍽', guestLabel: 'diners' }, 
  'Meeting/Workshop': { titlePrefix: 'Splendid! 💼', guestLabel: 'attendees' }, 
  'Team Activity': { titlePrefix: 'Sounds like fun! 🎉', guestLabel: 'participants' }, 
  'Presentation': { titlePrefix: 'Exciting! 🎤', guestLabel: 'attendees' }, 
  'Wedding': { titlePrefix: 'Congratulations! 💐', guestLabel: 'guests' }, 
  'Networking': { titlePrefix: 'Terrific! 🤝', guestLabel: 'guests' }, 
  'Studio': { titlePrefix: 'Awesome! 📸 🎧', guestLabel: 'superstars' }, 
  'Conference': { titlePrefix: 'Excellent! 🎤', guestLabel: 'attendees' }, 
  'Something Else': { titlePrefix: 'Marvelous! ✨', guestLabel: 'guests' },
}

const GuestNumberInput: InputView = ({path}): JSX.Element => {
  const { brief } = useBriefContext()
  const [numGuests, setNumGuests] = useState<number | ''>(brief.capacities ?? '')

  const { titlePrefix, guestLabel } = inputTextByType[brief.collectionName ?? '']
  const guestNumAttributes = { capacities: numGuests || undefined }
  const onChange: ChangeEventHandler<HTMLInputElement> = ({target}) => {
    setNumGuests(target.value && parseInt(target.value))
  }

  return (
    <FormPage
      metaTitle='Event size - HeadBox'
      heading={`${titlePrefix} Who's invited?`}
      path={path}
      inputAttributes={guestNumAttributes}
      className='guest-number-page'
      >
      <p className="contextual">
        I&#39;m expecting
        {' '}
        <label htmlFor='num-guests' className='visually-hidden'>Number of guests</label>
        <Input
          id='num-guests'
          type='number'
          min='1'
          max='1000000'
          step='1'
          value={numGuests}
          onChange={onChange}
          required
          />
        {' '}
        <span aria-hidden={true}>{guestLabel}</span>
      </p>
    </FormPage>
  )
}

export default GuestNumberInput
